import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { EditorialTicker } from "@/components/EditorialTicker";
import { RequirementsSection } from "@/components/RequirementsSection";
import { BenefitsSection } from "@/components/BenefitsSection";
import { HumanManifestoSection } from "@/components/HumanManifestoSection";
import { ApplicationForm } from "@/components/ApplicationForm";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/constants/brand";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 350);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <div data-testid="landing-page" className="bg-obsidian text-white">
      <Navbar />
      <HeroSection />
      <EditorialTicker />
      <RequirementsSection />
      <BenefitsSection />
      <HumanManifestoSection />
      <ApplicationForm />
      <Footer />
    </div>
  );
}
